import { render } from "./MUTT-Admin.vue?vue&type=template&id=a241233e&scoped=true"
import script from "./MUTT-Admin.vue?vue&type=script&lang=js"
export * from "./MUTT-Admin.vue?vue&type=script&lang=js"

import "./MUTT-Admin.vue?vue&type=style&index=0&id=a241233e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a241233e"]])

export default __exports__